import { render, staticRenderFns } from "./UploadPlanilha.vue?vue&type=template&id=b74b0ff2&lang=pug"
import script from "./UploadPlanilha.vue?vue&type=script&lang=js"
export * from "./UploadPlanilha.vue?vue&type=script&lang=js"
import style0 from "./UploadPlanilha.vue?vue&type=style&index=0&id=b74b0ff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports